import { createAsyncThunk } from "@reduxjs/toolkit";

import { instance } from "../../axios/axios";

export const addAdmin = createAsyncThunk(
  "admin/create",
  async (
    {
      first_name,
      last_name,
      email,
      username,
      password,
      phone,
      full_address,
      role,
      is_active,
    },
    { rejectWithValue, getState }
  ) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getState().auth.token}`,
        },
      };
      const { data, status } = await instance.post(
        "admins",
        {
          first_name,
          last_name,
          email,
          username,
          password,
          phone,
          full_address,
          role,
          is_active,
        },
        config
      );
      return { data, status };
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateAdmin = createAsyncThunk(
  "admin/update",
  async (
    {
      id,
      first_name,
      last_name,
      email,
      password,
      username,
      phone,
      full_address,
      role,
      is_active,
    },
    { rejectWithValue, getState }
  ) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getState().auth.token}`,
        },
      };
      const { data, status } = await instance.patch(
        `admins/${id}`,
        {
          first_name,
          last_name,
          email,
          password,
          username,
          phone,
          full_address,
          role,
          is_active,
        },
        config
      );
      return { data, status };
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteAdmin = createAsyncThunk(
  "admin/delete",
  async ({ admin_id }, { rejectWithValue, getState }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getState().auth.token}`,
        },
      };
      const { data, status } = await instance.delete(
        `admins/${admin_id}`,
        config
      );
      return { data, status };
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
